mutation RetryQueueMutation($queueName: String!) {
  retryQueue(queueName: $queueName) {
    id
    name
    jobCounts {
      waiting
      active
      completed
      failed
      delayed
    }
  }
}
